import { createContext, useState } from "react";

const UserAuthContext = createContext();

export const UserAuthProvider = ({ children }) => {
  const [userAuth, setUserAuth] = useState(null);
  const [tokenData, setTokenData] = useState(null);
  const [authStatusMsg, setAuthStatusMsg] = useState('');

  return (
    <UserAuthContext.Provider
      value={{
        userAuth,
        setUserAuth,
        authStatusMsg,
        setAuthStatusMsg,
        tokenData,
        setTokenData
      }}
    >
      {children}
    </UserAuthContext.Provider>
  )

}

export default UserAuthContext;